Hideaways.enquiryForm = function() {
    var enquiryForm = new EnquiryForm();
    enquiryForm.init();

    Hideaways._enquiryForm = enquiryForm;
}
